import { Guid, Nillable } from '@web/utils';
import { AdminOrderRefundDataItem } from './admin-order-refund-data-item';
import { AdminOrderRefundDataShipment } from './admin-order-refund-data-shipment';
import { FormArray, FormControl, FormGroup } from '@angular/forms';

export type RefundEntryControls = {
  identifier: FormControl<Guid>;
  amount: FormControl<Nillable<number>>;
};

export type PartialRefundControls = {
  items: FormArray<RefundEntryFormGroup>;
  shipments: FormArray<RefundEntryFormGroup>;
  comment: FormControl<Nillable<string>>;
};

export class AdminOrderRefundData {
  public static readonly CommentMaxLength = 10000;

  public constructor(
    private readonly data: {
      orderId: Guid;
      orderNumber: string;
      items: AdminOrderRefundDataItem[];
      shipments: AdminOrderRefundDataShipment[];
    },
  ) {}

  public get orderId(): Guid {
    return this.data.orderId;
  }

  public get orderNumber(): string {
    return this.data.orderNumber;
  }

  public get items(): AdminOrderRefundDataItem[] {
    return this.data.items;
  }

  public get shipments(): AdminOrderRefundDataShipment[] {
    return this.data.shipments;
  }
}

export type RefundEntryFormGroup = FormGroup<RefundEntryControls>;

export type PartialRefundFormGroup = FormGroup<PartialRefundControls>;
